import { render, staticRenderFns } from "./SeedTabs.vue?vue&type=template&id=2024e30a&"
import script from "./SeedTabs.vue?vue&type=script&lang=js&"
export * from "./SeedTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports